import script from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=584b83fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584b83fc"]])

export default __exports__